import dynamic from 'next/dynamic';
import Link from '@/_application/core/components/ui/link';
import {KidsLocation} from '@/_application/icons/kids-location';
import {Routes} from '@/config/routes';
import {useTranslation} from 'next-i18next';

const StoreSwitcher = dynamic(() => import('@/_application/core/components/commons/store-switcher'), {ssr: false});
interface IProps {
    storesNumber: number;
}
export const INIT_STORES_NUMBER = 159;
const TopNavHeader: React.FC<IProps> = ({storesNumber}) => {
    const {t} = useTranslation();

    return (
        <div className="relative z-2 flex h-10 items-center justify-center bg-secondary">
            <div className="relative z-2 flex w-[698px] items-center justify-between text-xs lg:w-[950px] xl:w-[1198px]">
                <div className="flex items-center">
                    <KidsLocation className="h-5 w-5" />
                    <p className="px-1 text-KPZ_text_1st">
                        {t('text-view-selling-price', 'Xem tồn kho, giá bán tại')}:
                    </p>
                    <StoreSwitcher />
                </div>

                <div className="flex items-center text-xs text-KPZ_text_1st">
                    <a href="tel:18006608" className="transition-colors hover:text-primary">
                        Hotline: 1800.6608
                    </a>
                    <div className="hidden items-center xl:flex">
                        <p className="px-2">|</p>
                        <Link className="transition-colors hover:text-primary" href={`${Routes.storeNearYou}`}>
                            Zalo cửa hàng
                        </Link>
                    </div>
                    <div className="hidden items-center xl:flex">
                        <p className="px-2">|</p>
                        <Link className="transition-colors hover:text-primary" href={`${Routes.appDownload}`}>
                            Ưu đãi khi tải app
                        </Link>
                    </div>
                    <div className="flex items-center">
                        <p className="px-2">|</p>
                        <Link className="transition-colors hover:text-primary" href={`${Routes.storeSystem}`}>
                            Hệ thống {storesNumber || INIT_STORES_NUMBER} cửa hàng
                        </Link>
                    </div>
                    <div className="hidden items-center xl:flex">
                        <p className="px-2">|</p>
                        <Link className="transition-colors hover:text-primary" href={`${Routes.memberIncentives}`}>
                            Thưởng Kicoin
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopNavHeader;
